


















































































import Vue from 'vue'
import Language from './Language.vue'
import { user } from '../fire'
export default Vue.extend({
	components: { Language },
	data() {
		return {
			user: user
		}
	},
	computed: {
		simplepay_link() {
			if (this.$locale() == 'hu') return 'http://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf'
			else return 'http://simplepartner.hu/PaymentService/Payment_information.pdf'
		}
	}
})
